<!--
 * @Author: your name
 * @Date: 2019-11-14 10:15:22
 * @LastEditTime: 2020-05-20 17:01:14
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \fontend_old_wap\src\pages\user\personal\weixin.vue
--> 
<template>
  <div class="forbang">
    <GlobTopNav title="微信解绑"></GlobTopNav>
    <div class="van-content">
      <div >
          <van-cell-group>
            <div to="/user/personal/weixin" class="van-cell van-hairline">
              <div class="van-cell__title">
                <span class="col-666">您已绑定微信</span>
              </div>
              <span class="col-333" v-html="this.$store.state.userCount.wechat_name"></span>
            </div>
          </van-cell-group>
          <van-cell-group style="background: transparent" >
            <van-cell style="background: transparent"><van-button size="large" class="theme-bg radius6" @click="relieve">解除微信绑定</van-button></van-cell>
          </van-cell-group>
      </div>
    </div>
  </div>
</template>

<script>
  import TopNav from '../../../components/topnav'


  export default {
    name: "index",
    components: {TopNav},
    props:['configData','userConfig'],
    data () {
      return {
        password:'',
        account:'',
        pwdType:false,
      }
    },
    methods: {
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        this.$refs.TopNav.topnavPlay()
      },
      changeType:function(){
        this.pwdType=!this.pwdType;//跟着小眼睛变化，密码框隐藏显示文本框，内容就显示了
      },
      relieve:function () {
        var mallid=localStorage.getItem("mallid");
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('user/wechat/delwechat',{id_example:mallid,token_user:isUser}, res => {
          if (res.data.code == '100') {
            this.$store.commit('userInfo')
            this.$router.push({ name: 'User' })
            this.$toast('微信解绑成功')
          }
        })
      },
    },
    mounted () {
        $('body').css('background','#fff')
    },
    destroyed: function () {
      $('body').css('background','#EFF3F6')
    },
  }
</script>

<style lang="less" scoped>
.forbang{
  background: #fff;
  .van-cell-group{
    background: #fff;
    margin-top: 10px;
    .van-cell:not(:last-child)::after{
      left: 0;
    }
  }
  .iconfont{
    vertical-align: middle;
    font-size: 20px;
    margin-right: 10px;
  }
  .van-cell:not(:last-child)::after {
    bottom: -22px;
  }
  .tishi{
    background: #D1EFD3;
    text-align: center!important;
    width: 80%;
    margin-left: 10%;
    padding: 15px 0;
    border-radius: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/personal/weixin.vue